import React, { Component } from "react";
import { Container, Stepper, Step, StepLabel, StepContent, Typography, Box } from "@material-ui/core";
import AppContext from "../appContext";
import Back from "../main/back";
import "./lente-pronta.css";
import Swal from "sweetalert2";
import CustomButton from "../components/buttons/button";
import LenteProntaEtapaUm from "./etapa-1/lente-pronta-etapa-um";
import LenteProntaEtapaDois from "./etapa-2/lente-pronta-etapa-dois";
import LenteProntaEtapaTres from "./etapa-3/lente-pronta-etapa-tres";
import LenteProntaEtapaQuatro from "./etapa-4/lente-pronta-etapa-quatro";
import LenteProntaEtapaCinco from "./etapa-5/lente-pronta-etapa-cinco";
import AvisoSemServicos from "./aviso-sem-servicos/aviso-sem-servicos";
import { validateFields, reset } from "../components/utils/Validate-Fields";
import ImageCarousel from "../components/carousel/ImageCarousel";
import { redirectPage } from "../components/utils/redirectpage";
import { Redirect } from "react-router";
import { getPactoOtica } from "../Functions/gestao-pedidos-laboratorios/pacto/pacto-otica";
import { getVouchers } from "../Functions/gestao-pedidos-laboratorios/pacto/vouchers";
import { getDioptrias } from "../Functions/dioptrias/getDioptrias";
import { getAccountData } from "../Functions/account-data/get-account-data";
import { validarRelacionamentoOtica } from "./utils/validar-relacionamento-otica";
import { montarProdutosPayload } from "./utils/montar-produtos-payload";
import SummaryAccordion from "../shared/components/generic/summary-accordion/summary-accordion";
import lenteProntaLogo from "./img/lente-pronta-logo.png";
import { swalOnOpen } from "../shared/utils/swal-animations";
import CnpjUtils from "../shared/utils/CnpjUtils";

class LentePronta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectL: false,
      redirectHome: false,
      numeroPedido: "",
      laboratorio: {},
      hasLaboratorio: false,
      otica: {
        redeOticas: false,
      },
      redeOticas: false,
      empresaFaturamento: "",
      dados_empresa_faturamento_cnpj: "",
      codigoParticipante: "",
      tipo_producao: "LENTES_PRONTA",
      tipo_produto: "VISAO_SIMPLES",
      produtos: [],
      rpl: "",
      linhaProduto: { codigo: "", nome: "" },
      produtoResolvido: false,
      fieldErrors: {},
      prescricaoOlhos: "ambos",
      prescricao_OD: { esferico: "", cilindrico: "" },
      prescricao_OE: { esferico: "", cilindrico: "" },
      observacao: "",
      hasOrcamento: false,
      disableFields: false,
      IsPacto: false,
      resolvendoProduto: false,
      buscandoVoucher: false,
      dominiosDioptria: { esferico: null, cilindrico: null },
      pacto: {
        status: false,
        temVoucher: false,
        tentativaConcluida: false,
        data: null,
        useVoucher: false,
        vouchers: [],
      },
      orcamento: {
        dataPrevistaEntrega: "",
        valorLiquido: 0,
      },
      open: "",
      arrow: "",
    };

    LentePronta.contextType = AppContext;

    this.handleChange = this.handleChange.bind(this);
    this.validarPedido = this.validarPedido.bind(this);
    this.corrigirPedido = this.corrigirPedido.bind(this);
    this.openSummary = this.openSummary.bind(this);

    if (sessionStorage.getItem("token") !== null) {
      var token = sessionStorage.getItem("token");
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

      var jwt = JSON.parse(jsonPayload);
      this.setState({ name: jwt.usuario.nome, cpf: jwt.usuario.cpf });

      const role = jwt.modulos.find(element => element === "Lente Pronta");
      if (!role) {
        this.state = { redirect: true };
      }
      if (this.props.location.state === undefined) {
        this.state = { redirectHome: true };
      }
    } else {
      this.state = { redirectL: true };
    }
  }

  handleChange(change, callback) {
    const clearErrors = {};
    if (change.numeroPedido !== undefined) clearErrors["input-numero-pedido"] = false;
    if (change.linhaProduto !== undefined) clearErrors["inputProduto"] = false;
    if (change.prescricao_OD !== undefined) {
      if (change.prescricao_OD.esferico !== undefined) clearErrors["esferico_OD"] = false;
      if (change.prescricao_OD.cilindrico !== undefined) clearErrors["cilindrico_OD"] = false;
    }
    if (change.prescricao_OE !== undefined) {
      if (change.prescricao_OE.esferico !== undefined) clearErrors["esferico_OE"] = false;
      if (change.prescricao_OE.cilindrico !== undefined) clearErrors["cilindrico_OE"] = false;
    }
    if (change.dados_empresa_faturamento_cnpj !== undefined) {
      clearErrors["selectEmpresaFaturamento"] = false;
      clearErrors["input-empresa-faturamento-cnpj"] = false;
    }

    Object.keys(clearErrors).forEach(id => this.resetErrorStyles(id));

    this.setState(prev => ({
      ...change,
      fieldErrors: { ...prev.fieldErrors, ...clearErrors },
    }), () => {
      if (change.dados_empresa_faturamento_cnpj !== undefined) {
        this.gerenciarValidacaoOticaCnpj(change.dados_empresa_faturamento_cnpj);
      }
      if (callback) {
        callback();
      }
    });
  }

  gerenciarValidacaoOticaCnpj(cnpj) {
    const clean = CnpjUtils.cleanCnpj(cnpj);
    const podeValidar =
      this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios") ||
      this.context.userSession.papelCategoria === "ESSILOR";

    if (!podeValidar) return;

    const userCnpj = CnpjUtils.cleanCnpj(this.context.userSession.conta);
    if (clean === userCnpj) {
      this._ultimaConsultaNomeOtica = clean;
      this._cnpjValidado = clean;
      this.setState(prev => ({
        empresaFaturamento: prev.otica?.nome || prev.empresaFaturamento || "",
        dados_empresa_faturamento: prev.otica?.nome || prev.dados_empresa_faturamento || "",
      }));
      return;
    }

    if (clean.length !== 14) {
      this._ultimaConsultaNomeOtica = null;
      this._cnpjValidado = null;
      this.setState({ empresaFaturamento: "", dados_empresa_faturamento: "" });
      return;
    }

    if (this._ultimaConsultaNomeOtica === clean) return;
    this.validarOticaCnpj(clean);
  }

  exibirErroCnpjSwal(mensagem) {
    Swal.fire({
      html: `${mensagem}<br/><br/><span style="font-size:0.875rem;color:#6c757d">Em caso de dúvidas, entre em contato com o laboratório.</span>`,
      icon: "warning",
      title: "Aviso",
      width: "600px",
      confirmButtonColor: "#00518b",
      customClass: { confirmButton: "x-follow-order__filter-btn" },
      onOpen: swalOnOpen,
    });
  }

  async validarOticaCnpj(cnpj) {
    this._ultimaConsultaNomeOtica = cnpj;
    this._cnpjValidado = null;

    const labCnpj = this.state.laboratorio?.cnpj;
    if (!labCnpj) {
      this.exibirErroCnpjSwal("Laboratório não identificado.");
      return;
    }

    try {
      const relacionamento = await validarRelacionamentoOtica(labCnpj, cnpj);

      if (this._ultimaConsultaNomeOtica !== cnpj) return;

      if (relacionamento.status >= 500 || relacionamento.status === 0) {
        this.setState({ empresaFaturamento: "", dados_empresa_faturamento: "" });
        this.exibirErroCnpjSwal(relacionamento.mensagem || "Não foi possível verificar o relacionamento com o laboratório. Tente novamente.");
        return;
      }

      if (!relacionamento.ok) {
        this.setState({ empresaFaturamento: "", dados_empresa_faturamento: "" });
        this.exibirErroCnpjSwal(relacionamento.mensagem || "Cliente sem relacionamento com o laboratório selecionado.");
        return;
      }

      let nome = "";
      try {
        const accountData = await getAccountData(cnpj);
        if (this._ultimaConsultaNomeOtica !== cnpj) return;
        nome = (accountData && accountData.nome) || "";
      } catch {
        if (this._ultimaConsultaNomeOtica !== cnpj) return;
      }

      this._cnpjValidado = cnpj;
      this.setState({ empresaFaturamento: nome, dados_empresa_faturamento: nome });
    } catch {
      if (this._ultimaConsultaNomeOtica !== cnpj) return;
      this.exibirErroCnpjSwal("Não foi possível verificar a ótica. Tente novamente.");
    }
  }

  openSummary(e) {
    this.setState({ [e.target.id]: e.target.value }, () => {
      if (this.state.open) {
        this.setState({ open: "", arrow: "" });
      } else {
        this.setState({ open: "show-summary", arrow: "active-arrow" });
      }
    });
  }

  componentDidMount() {
    redirectPage(this.context.userSession, "/lente-pronta-pedido");
    this.context.showLoading("");

    if (this.props.location.state !== undefined) {
      const hasLaboratorio = this.props.location.state.labCnpj;
      const laboratorio = this.props.location.state.laboratorio;

      if (hasLaboratorio && laboratorio) {
        this.handleChange(
          {
            hasLaboratorio: this.props.location.state.labCnpj,
            laboratorio: this.props.location.state.laboratorio,
          },
          () => {
            this.getOtica();
            this.checkPacto();
          },
        );
      }
    }
  }

  getOtica() {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cnpj: this.context.userSession.conta }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions)
      .then(response => response.json())
      .then(json => {
        if (this.context.userSession.redeOticas) {
          this.setState(
            {
              otica: { nome: json.nome, cnpj: json.cnpj },
              empresaFaturamento: json.nome,
              cnpjOticaPrincipal: json.cnpj,
            },
            () => this.listarRedesOticas(),
          );
        } else if (!this.state.empresaFaturamento) {
          this.setState({
            otica: { nome: json.nome, cnpj: json.cnpj },
            redeOticas: false,
            empresaFaturamento: json.nome,
            dados_empresa_faturamento: json.nome,
            dados_empresa_faturamento_cnpj: json.cnpj,
            hasLaboratorio: this.state.laboratorio.cnpj,
          });
          this.context.hideLoading();
        }
      });
  }

  listarRedesOticas = () => {
    this.context.showLoading("");
    if (this.context.userSession.modulos.includes("Consulta Rede")) {
      const requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          laboratorio: this.state.laboratorio.cnpj,
        },
      };

      fetch(process.env.REACT_APP_ESSILOR_API + "gestao-laboratorios/v1/redes", requestOptions)
        .then(response => {
          return response.json().then(json => {
            if (json.participantes) {
              const redes = [];
              json.participantes.map((value) => {
                if (value.cnpj === this.state.cnpjOticaPrincipal) {
                  this.setState({
                    otica: { nome: value.descricao, cnpj: value.cnpj },
                    empresaFaturamento: value.descricao,
                    dados_empresa_faturamento_cnpj: value.cnpj,
                  });
                }
                redes.push({ label: value.descricao, value: value.cnpj });
              });
              this.setState({ redes: redes, redeOticas: true });
            } else {
              this.setState({
                redeOticas: false,
                empresaFaturamento: this.state.otica.nome,
                dados_empresa_faturamento: this.state.otica.nome,
                dados_empresa_faturamento_cnpj: this.state.otica.cnpj,
              });
            }
            this.context.hideLoading();
          });
        })
        .catch(() => {
          this.setState({
            redeOticas: false,
            empresaFaturamento: this.state.otica.nome,
            dados_empresa_faturamento: this.state.otica.nome,
            dados_empresa_faturamento_cnpj: this.state.otica.cnpj,
          });
          this.context.hideLoading();
        });
    } else {
      this.setState({
        redeOticas: false,
        empresaFaturamento: this.state.otica.nome,
        dados_empresa_faturamento: this.state.otica.nome,
        dados_empresa_faturamento_cnpj: this.state.otica.cnpj,
      });
      this.context.hideLoading();
    }
  };

  checkPacto() {
    if (this.state.laboratorio.IsPacto) {
      this.setState({ IsPacto: true });
      const cnpjOtica = this.state.dados_empresa_faturamento_cnpj || this.context.userSession.conta;
      getPactoOtica(cnpjOtica, this.state.laboratorio.cnpj)
        .then(response => {
          if (response.status === 200 && !response.mensagem?.descMensagem?.includes("Nenhum voucher")) {
            this.setState({
              pacto: {
                ...this.state.pacto,
                status: true,
                data: response.mensagem,
              },
            });
          }
        })
        .catch(() => {});
    }
  }

  voucherPacto = () => {
    if (this.state.IsPacto && this.state.rpl) {
      const cnpjOtica = this.state.dados_empresa_faturamento_cnpj || this.context.userSession.conta;
      getVouchers(cnpjOtica, this.state.laboratorio.cnpj, this.state.rpl, null)
        .then(response => {
          if (response.status === 200 && response.mensagem?.length > 0) {
            this.setState({
              buscandoVoucher: false,
              pacto: {
                ...this.state.pacto,
                temVoucher: true,
                tentativaConcluida: true,
                vouchers: response.mensagem,
              },
            });
          } else {
            this.setState({
              buscandoVoucher: false,
              pacto: {
                ...this.state.pacto,
                temVoucher: false,
                tentativaConcluida: true,
                vouchers: [],
              },
            });
          }
        })
        .catch(() => {
          this.setState({
            buscandoVoucher: false,
            pacto: {
              ...this.state.pacto,
              temVoucher: false,
              vouchers: [],
            },
          });
        });
    }
  };

  resolverProduto = () => {
    const { linhaProduto, prescricaoOlhos, prescricao_OD, prescricao_OE } = this.state;

    if (!linhaProduto.codigo) return;

    if (this.state.IsPacto && this._ultimaConsultaRplAntecipado !== linhaProduto.codigo) {
      this._ultimaConsultaRplAntecipado = linhaProduto.codigo;
      this.setState(prev => ({
        buscandoVoucher: true,
        pacto: { ...prev.pacto, tentativaConcluida: false, temVoucher: false, vouchers: [] },
      }));
      this.buscarRpl(linhaProduto.codigo);
    }

    if (this._ultimaConsultaDominios !== linhaProduto.codigo) {
      this._ultimaConsultaDominios = linhaProduto.codigo;
      this.buscarDominiosDioptria(linhaProduto.codigo);
    }

    const olhos = this.montarOlhosPrescricao(prescricaoOlhos, prescricao_OD, prescricao_OE);
    if (olhos.some(olho => !olho.esferico || !olho.cilindrico)) return;

    const chave = this.chaveConsultaProduto(linhaProduto.codigo, olhos);
    if (chave === this._ultimaConsultaProduto) return;
    this._ultimaConsultaProduto = chave;

    this.setState({ resolvendoProduto: true });

    let requestOptions;
    if (
      (this.state?.redes?.length > 0 && this.context.userSession.redeOticas) ||
      this.context.userSession.papelCategoria === "ESSILOR"
    ) {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: this.state.laboratorio.cnpj,
          otica: this.state.dados_empresa_faturamento_cnpj,
        },
      };
    } else {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: this.state.laboratorio.cnpj,
        },
      };
    }

    const consultas = new Map();
    olhos.forEach(olho => {
      const chaveDioptria = `${olho.esferico}_${olho.cilindrico}`;
      if (consultas.has(chaveDioptria)) return;
      const esf = encodeURIComponent(olho.esferico);
      const cil = encodeURIComponent(olho.cilindrico);
      const url = `${process.env.REACT_APP_ESSILOR_API}gestao-produtos-laboratorio/v1/produtos-atacado?tipoProduto=LENTE_SIMPLES&codigoLinhaProduto=${linhaProduto.codigo}&grauEsferico=${esf}&grauCilindrico=${cil}`;
      consultas.set(
        chaveDioptria,
        fetch(url, requestOptions).then(async response => {
          let body = null;
          try {
            body = await response.json();
          } catch {
            body = null;
          }
          return { status: response.status, body };
        }),
      );
    });

    Promise.all(olhos.map(olho => consultas.get(`${olho.esferico}_${olho.cilindrico}`)))
      .then(respostas => {
        const olhosAtuais = this.montarOlhosPrescricao(this.state.prescricaoOlhos, this.state.prescricao_OD, this.state.prescricao_OE);
        const chaveAtual = this.chaveConsultaProduto(this.state.linhaProduto.codigo, olhosAtuais);
        if (chaveAtual !== chave) {
          this.setState({ resolvendoProduto: false });
          return;
        }

        const resultados = respostas.map(({ status, body }) => ({
          status,
          body,
          encontrado:
            status === 200 &&
            Array.isArray(body) &&
            body.length > 0 &&
            body[0].codigo &&
            body[0].codigo !== "NAO_ENCONTRADO",
        }));

        if (resultados.every(resultado => resultado.encontrado)) {
          this.setState(prev => ({
            produtos: resultados.map(resultado => ({ codigo: resultado.body[0].codigo, descricao: resultado.body[0].descricao })),
            produtoResolvido: true,
            resolvendoProduto: false,
            fieldErrors: {
              ...prev.fieldErrors,
              esferico_OD: false,
              cilindrico_OD: false,
              esferico_OE: false,
              cilindrico_OE: false,
            },
          }));
          return;
        }

        this._ultimaConsultaProduto = null;
        const camposComErro = {};
        olhos.forEach((olho, indice) => {
          if (resultados[indice].encontrado) return;
          if (olho.olho === "OD") {
            camposComErro.esferico_OD = true;
            camposComErro.cilindrico_OD = true;
          } else {
            camposComErro.esferico_OE = true;
            camposComErro.cilindrico_OE = true;
          }
        });
        this.setState(prev => ({
          produtos: [],
          produtoResolvido: false,
          resolvendoProduto: false,
          fieldErrors: { ...prev.fieldErrors, ...camposComErro },
        }));

        const falha = resultados.find(resultado => !resultado.encontrado);
        let mensagem;
        if (falha.status === 200) {
          mensagem =
            "Nenhum produto encontrado para a combinação de linha e prescrição selecionada. Ajuste os valores ou escolha outro produto.";
        } else if (falha.status >= 500) {
          mensagem = "Falha de comunicação com o laboratório. Tente novamente mais tarde.";
        } else if (falha.status >= 400) {
          mensagem =
            (Array.isArray(falha.body) && falha.body[0]?.mensagem) ||
            falha.body?.mensagem ||
            "Erro ao processar a solicitação. Tente novamente.";
        } else {
          mensagem = "Erro ao processar a solicitação. Tente novamente.";
        }

        Swal.fire({
          text: mensagem,
          icon: "warning",
          title: "Aviso",
          confirmButtonColor: "#00518b",
          customClass: { confirmButton: "x-follow-order__filter-btn" },
          onOpen: swalOnOpen,
        });
      })
      .catch(() => {
        this._ultimaConsultaProduto = null;
        this.setState({ produtoResolvido: false, resolvendoProduto: false, produtos: [] });
        Swal.fire({
          text: "Falha de comunicação com o laboratório. Tente novamente mais tarde.",
          icon: "warning",
          title: "Aviso",
          confirmButtonColor: "#00518b",
          customClass: { confirmButton: "x-follow-order__filter-btn" },
          onOpen: swalOnOpen,
        });
      });
  };

  montarOlhosPrescricao = (prescricaoOlhos, prescricao_OD, prescricao_OE) => {
    const olhos = [];
    if (prescricaoOlhos !== "esquerdo") {
      olhos.push({ olho: "OD", esferico: prescricao_OD.esferico, cilindrico: prescricao_OD.cilindrico });
    }
    if (prescricaoOlhos !== "direito") {
      olhos.push({ olho: "OE", esferico: prescricao_OE.esferico, cilindrico: prescricao_OE.cilindrico });
    }
    return olhos;
  };

  chaveConsultaProduto = (codigoLinha, olhos) =>
    `${codigoLinha}_${olhos.map(olho => `${olho.olho}_${olho.esferico}_${olho.cilindrico}`).join("_")}`;

  buscarRpl = (codigoProduto) => {
    let requestOptions;
    if (
      (this.state?.redes?.length > 0 && this.context.userSession.redeOticas) ||
      this.context.userSession.papelCategoria === "ESSILOR"
    ) {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: this.state.laboratorio.cnpj,
          otica: this.state.dados_empresa_faturamento_cnpj,
        },
      };
    } else {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: this.state.laboratorio.cnpj,
        },
      };
    }

    const codigoBase = codigoProduto.split(/[+-]/)[0];
    const url = `${process.env.REACT_APP_ESSILOR_API}gestao-produtos-laboratorio/v1/produtos/${codigoBase}/parametros`;

    fetch(url, requestOptions)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return null;
      })
      .then(json => {
        if (json && json.rpl) {
          this.setState({
            rpl: json.rpl,
          }, () => this.voucherPacto());
        } else {
          this.setState(prev => ({
            buscandoVoucher: false,
            pacto: { ...prev.pacto, tentativaConcluida: true, temVoucher: false, vouchers: [] },
          }));
        }
      })
      .catch(() => {
        this.setState(prev => ({
          buscandoVoucher: false,
          pacto: { ...prev.pacto, tentativaConcluida: true, temVoucher: false, vouchers: [] },
        }));
      });
  };

  buscarDominiosDioptria = async (codigoLinha) => {
    try {
      const codigoBase = codigoLinha.split(/[+-]/)[0];
      const response = await getDioptrias("LENTE_SIMPLES", codigoBase, this.state.laboratorio.cnpj);
      if (response && response.status === 200 && response.esferico?.length > 0 && response.cilindrico?.length > 0) {
        const esfericoValues = response.esferico.map(o => o.value);
        const cilindricoValues = response.cilindrico.map(o => o.value);
        const { prescricao_OD, prescricao_OE } = this.state;

        const novoOD = { ...prescricao_OD };
        if (prescricao_OD.esferico && !esfericoValues.includes(prescricao_OD.esferico)) {
          novoOD.esferico = "";
        }
        if (prescricao_OD.cilindrico && !cilindricoValues.includes(prescricao_OD.cilindrico)) {
          novoOD.cilindrico = "";
        }

        const novoOE = { ...prescricao_OE };
        if (prescricao_OE.esferico && !esfericoValues.includes(prescricao_OE.esferico)) {
          novoOE.esferico = "";
        }
        if (prescricao_OE.cilindrico && !cilindricoValues.includes(prescricao_OE.cilindrico)) {
          novoOE.cilindrico = "";
        }

        const prescricaoMudou =
          novoOD.esferico !== prescricao_OD.esferico ||
          novoOD.cilindrico !== prescricao_OD.cilindrico ||
          novoOE.esferico !== prescricao_OE.esferico ||
          novoOE.cilindrico !== prescricao_OE.cilindrico;

        if (prescricaoMudou) {
          this._ultimaConsultaProduto = null;
        }

        this.setState(prev => ({
          dominiosDioptria: {
            esferico: response.esferico,
            cilindrico: response.cilindrico,
          },
          prescricao_OD: novoOD,
          prescricao_OE: novoOE,
          fieldErrors: prescricaoMudou
            ? { ...prev.fieldErrors, esferico_OD: false, cilindrico_OD: false, esferico_OE: false, cilindrico_OE: false }
            : prev.fieldErrors,
        }));
      } else {
        this.setState({ dominiosDioptria: { esferico: null, cilindrico: null } });
      }
    } catch {
      this.setState({ dominiosDioptria: { esferico: null, cilindrico: null } });
    }
  };

  applyErrorStyles = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.style.boxShadow = "0 0 0 1px #f70017";
    el.style.borderRadius = "5px";
  };

  resetErrorStyles = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.style.boxShadow = "";
    el.style.borderRadius = "";
  };

  highlightField = (id) => {
    this.applyErrorStyles(id);
    this.setState(prev => ({ fieldErrors: { ...prev.fieldErrors, [id]: true } }));
  };

  clearHighlight = (id) => {
    this.resetErrorStyles(id);
    this.setState(prev => ({ fieldErrors: { ...prev.fieldErrors, [id]: false } }));
  };

  focarNoInput = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    const focusable = el.querySelector("input, textarea, select") || el;
    try {
      focusable.focus({ preventScroll: true });
      if (typeof focusable.select === "function") {
        focusable.select();
      }
    } catch {}
  };

  validarPedido() {
    let valido = true;
    let primeiroIdErro = null;
    const camposFaltantes = [];
    const labelsCampos = {
      "input-numero-pedido": "Nº do pedido da ótica",
      "input-empresa-faturamento-cnpj": "CNPJ da Empresa de faturamento",
      "selectEmpresaFaturamento": "Empresa de faturamento",
      "inputProduto": "Produto",
      "esferico_OD": "Esférico (Olho direito)",
      "cilindrico_OD": "Cilíndrico (Olho direito)",
      "esferico_OE": "Esférico (Olho esquerdo)",
      "cilindrico_OE": "Cilíndrico (Olho esquerdo)",
      "input-voucher-pacto-code": "Código do voucher Pacto",
    };
    const registrarErro = (id) => {
      this.highlightField(id);
      if (!primeiroIdErro) primeiroIdErro = id;
      const label = labelsCampos[id] || id;
      if (!camposFaltantes.includes(label)) camposFaltantes.push(label);
      valido = false;
    };

    const cnpjLimpo = CnpjUtils.cleanCnpj(this.state.dados_empresa_faturamento_cnpj);
    const podeValidarCnpj =
      this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios") ||
      this.context.userSession.papelCategoria === "ESSILOR";
    const userCnpj = CnpjUtils.cleanCnpj(this.context.userSession.conta);
    const exigeValidacaoCnpj = podeValidarCnpj && !this.state.redeOticas && cnpjLimpo !== userCnpj;
    if (exigeValidacaoCnpj && cnpjLimpo.length === 14 && this._cnpjValidado !== cnpjLimpo) {
      registrarErro("input-empresa-faturamento-cnpj");
    }

    if (!this.state.numeroPedido) {
      registrarErro("input-numero-pedido");
    } else {
      this.clearHighlight("input-numero-pedido");
    }

    if (!this.state.dados_empresa_faturamento_cnpj) {
      registrarErro(this.state.redeOticas ? "selectEmpresaFaturamento" : "input-empresa-faturamento-cnpj");
    } else {
      this.clearHighlight("selectEmpresaFaturamento");
      if (!exigeValidacaoCnpj || cnpjLimpo === this._cnpjValidado) {
        this.clearHighlight("input-empresa-faturamento-cnpj");
      }
    }

    if (!this.state.linhaProduto.codigo) {
      registrarErro("inputProduto");
    } else {
      this.clearHighlight("inputProduto");
    }

    if (this.state.prescricaoOlhos !== "esquerdo") {
      if (!this.state.prescricao_OD.esferico) {
        registrarErro("esferico_OD");
      } else if (this.state.produtoResolvido) {
        this.clearHighlight("esferico_OD");
      }
      if (!this.state.prescricao_OD.cilindrico) {
        registrarErro("cilindrico_OD");
      } else if (this.state.produtoResolvido) {
        this.clearHighlight("cilindrico_OD");
      }
    }

    if (this.state.prescricaoOlhos !== "direito") {
      if (!this.state.prescricao_OE.esferico) {
        registrarErro("esferico_OE");
      } else if (this.state.produtoResolvido) {
        this.clearHighlight("esferico_OE");
      }
      if (!this.state.prescricao_OE.cilindrico) {
        registrarErro("cilindrico_OE");
      } else if (this.state.produtoResolvido) {
        this.clearHighlight("cilindrico_OE");
      }
    }

    if (this.state.pacto?.voucherIncompleto) {
      registrarErro("input-voucher-pacto-code");
    }

    if (!valido) {
      const listaCampos = camposFaltantes.map(c => `• ${c}`).join("<br/>");
      Swal.fire({
        html: `Preencha os campos obrigatórios para validar o pedido:<br/><br/>${listaCampos}`,
        icon: "warning",
        title: "Aviso",
        confirmButtonColor: "#00518b",
        customClass: { confirmButton: "x-follow-order__filter-btn" },
        onOpen: swalOnOpen,
      }).then(() => {
        if (primeiroIdErro) this.focarNoInput(primeiroIdErro);
      });
      return;
    }

    if (!this.state.produtoResolvido) {
      Swal.fire({
        text: "Produto não disponível para a prescrição informada. Verifique os graus selecionados.",
        icon: "warning",
        title: "Aviso",
        confirmButtonColor: "#00518b",
        customClass: { confirmButton: "x-follow-order__filter-btn" },
        onOpen: swalOnOpen,
      });
      return;
    }

    this.context.showLoading("Validando pedido...");

    let body = {
      idPedidoOtica: this.state.numeroPedido,
      observacao: this.state.observacao || "",
      produtos: montarProdutosPayload(this.state.produtos, this.state.rpl),
      vendedor: {
        nome: this.context.userSession.nome + " " + this.context.userSession.sobrenome,
        cpf: this.context.userSession.cpf,
      },
    };

    if (this.state.codigoParticipante) {
      body.programaLaboratorio = { codigoParticipante: this.state.codigoParticipante };
    }

    if (this.state.pacto.useVoucher && this.state.pacto.selectedVoucher) {
      body.cortesia = {
        voucher: this.state.pacto.selectedVoucher.id,
        codigoVoucher: this.state.pacto.selectedVoucher.codigo,
      };
    }

    let headers = {
      "Content-Type": "application/json",
      access_token: sessionStorage.getItem("token"),
      laboratorio: this.state.laboratorio.cnpj,
    };

    if (
      (this.state?.redes?.length > 0 && this.context.userSession.redeOticas) ||
      this.context.userSession.papelCategoria === "ESSILOR"
    ) {
      headers.otica = this.state?.dados_empresa_faturamento_cnpj;
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    };

    fetch(`${process.env.REACT_APP_ESSILOR_API}gestao-pedidos-laboratorio/v1/lente-pronta/orcamentos`, requestOptions)
      .then(response => {
        if (response.status === 201) {
          return response.json();
        } else if (response.status >= 400 && response.status < 499) {
          return response.json().then(json => {
            this.context.hideLoading();
            Swal.fire({
              html: json[0]?.mensagem || "Erro ao validar pedido.",
              icon: "warning",
              title: "Aviso",
              width: "600px",
              confirmButtonColor: "#00518b",
              customClass: { confirmButton: "x-follow-order__filter-btn" },
            });
          });
        } else if (response.status === 504) {
          this.context.hideLoading();
          Swal.fire({
            html: "A requisição atingiu o tempo máximo de processamento. Tente novamente mais tarde.",
            icon: "warning",
            title: "Aviso",
            width: "600px",
            confirmButtonColor: "#00518b",
            customClass: { confirmButton: "x-follow-order__filter-btn" },
          });
        } else {
          this.context.hideLoading();
          Swal.fire({
            html: "Tivemos uma falha momentânea de comunicação com o laboratório.",
            icon: "error",
            width: "600px",
            confirmButtonColor: "#00518b",
            customClass: { confirmButton: "x-follow-order__filter-btn" },
          });
        }
      })
      .then(json => {
        if (json) {
          this.setState({
            orcamento: {
              dataPrevistaEntrega: json.dataEntregaPrevista,
              valorLiquido: json.valorLiquido,
            },
            hasOrcamento: true,
            disableFields: true,
          });
          this.context.hideLoading();
        }
      });
  }

  corrigirPedido() {
    this.setState({ hasOrcamento: false, disableFields: false });
  }

  render() {
    const { disableFields } = this.state;
    const temModuloPedidos = (this.context.userSession?.modulos || []).includes("Pedidos");

    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }
    if (this.state.redirectL) {
      return <Redirect to="/" />;
    }
    if (this.state.redirectHome) {
      return <Redirect to="/lente-pronta" />;
    }

    return (
      <main className="lente-pronta">
        <div className="lente-pronta__layout">
          {this.state.hasLaboratorio && (
            <>
              <div className="lente-pronta__form-column">
                <Back title="Conecta Lente Pronta" items={[
                    { label: 'Seleção de Laboratório', path: '/lente-pronta' },
                    { label: this.state.laboratorio.nome || 'Laboratório' },
                  ]} />
                <Container maxWidth="lg" disableGutters style={{ marginTop: "4rem" }}>
                  {!this.state.hasOrcamento ? (
                    <>
                      <ImageCarousel labCnpj={this.state.laboratorio.cnpj} />
                      <AvisoSemServicos id="link-conecta-pedidos-topo" comLink={temModuloPedidos} />
                      <Stepper orientation="vertical" activeStep={-1} className="lp-stepper">
                        <Step expanded active>
                          <StepLabel>Insira os dados do pedido e solicitante</StepLabel>
                          <StepContent>
                            <LenteProntaEtapaUm
                              empresaFaturamento={this.state.empresaFaturamento}
                              otica={this.state.otica}
                              redes={this.state.redes}
                              redeOticas={this.state.redeOticas}
                              numeroPedido={this.state.numeroPedido}
                              disableFields={disableFields}
                              dados_empresa_faturamento_cnpj={this.state.dados_empresa_faturamento_cnpj}
                              onChange={this.handleChange}
                              PossuiProgramaFidelidadeProprio_c={this.props.location.state?.laboratorio?.PossuiProgramaFidelidadeProprio_c}
                              fieldErrors={this.state.fieldErrors}
                            />
                          </StepContent>
                        </Step>
                        <Step expanded active>
                          <StepLabel>Produto</StepLabel>
                          <StepContent>
                            <LenteProntaEtapaDois
                              labId={this.state.laboratorio.Id}
                              labcnpj={this.state.laboratorio.cnpj}
                              tipo_produto={this.state.tipo_produto}
                              tipo_producao={this.state.tipo_producao}
                              onChange={this.handleChange}
                              disableFields={disableFields}
                              linhaProduto={this.state.linhaProduto}
                              IsPacto={this.state.IsPacto}
                              pacto={this.state.pacto}
                              voucherPacto={this.voucherPacto}
                              onProdutoChange={this.resolverProduto}
                              produtoResolvido={this.state.produtoResolvido}
                              resolvendoProduto={this.state.resolvendoProduto}
                              buscandoVoucher={this.state.buscandoVoucher}
                              laboratorio={this.state.laboratorio}
                              dados_empresa_faturamento_cnpj={this.state.dados_empresa_faturamento_cnpj}
                              redes={this.state.redes}
                              clearHighlight={this.clearHighlight}
                              fieldErrors={this.state.fieldErrors}
                            />
                          </StepContent>
                        </Step>
                        <Step expanded active>
                          <StepLabel>Prescrição</StepLabel>
                          <StepContent>
                            <LenteProntaEtapaTres
                              prescricaoOlhos={this.state.prescricaoOlhos}
                              prescricao_OD={this.state.prescricao_OD}
                              prescricao_OE={this.state.prescricao_OE}
                              disableFields={disableFields}
                              resolvendoProduto={this.state.resolvendoProduto}
                              buscandoVoucher={this.state.buscandoVoucher}
                              linhaProduto={this.state.linhaProduto}
                              laboratorio={this.state.laboratorio.cnpj}
                              dominiosDioptria={this.state.dominiosDioptria}
                              onChange={this.handleChange}
                              onPrescricaoChange={this.resolverProduto}
                              clearHighlight={this.clearHighlight}
                              fieldErrors={this.state.fieldErrors}
                            />
                          </StepContent>
                        </Step>
                        <Step expanded active>
                          <StepLabel>Dados adicionais</StepLabel>
                          <StepContent>
                            <LenteProntaEtapaQuatro
                              disableFields={disableFields}
                              onChange={this.handleChange}
                              observacao={this.state.observacao}
                            />
                          </StepContent>
                        </Step>
                      </Stepper>
                      <AvisoSemServicos id="link-conecta-pedidos-rodape" comLink={temModuloPedidos} />
                      <div className="float-end" style={{ marginTop: "1.5rem" }}>
                        <CustomButton
                          id="btn-validar-pedido"
                          label="Validar Pedido"
                          width="200px"
                          icon_search={false}
                          icon_arrow_left={false}
                          icon_arrow_right={true}
                          onClick={this.validarPedido}
                          disabled={this.state.resolvendoProduto || this.state.buscandoVoucher}
                        />
                      </div>
                    </>
                  ) : (
                    <LenteProntaEtapaCinco
                      pedidoOtica={this.state.numeroPedido}
                      orcamento={this.state.orcamento}
                      empresa_faturamento={this.state.empresaFaturamento}
                      dados_empresa_faturamento_cnpj={this.state.dados_empresa_faturamento_cnpj}
                      labCnpj={this.state.laboratorio.cnpj}
                      labName={this.state.laboratorio?.nome || ""}
                      labLogo={this.state.laboratorio?.logo || ""}
                      corrigirPedido={this.corrigirPedido}
                      produtos={this.state.produtos}
                      rpl={this.state.rpl}
                      linhaProduto={this.state.linhaProduto}
                      prescricaoOlhos={this.state.prescricaoOlhos}
                      prescricao_OD={this.state.prescricao_OD}
                      prescricao_OE={this.state.prescricao_OE}
                      observacao={this.state.observacao}
                      otica={this.state.otica}
                      redeOticas={this.state.redeOticas}
                      codigoParticipante={this.state.codigoParticipante}
                      pacto={this.state.pacto}
                      redes={this.state.redes}
                    />
                  )}
                </Container>
              </div>

              <div
                className={`x-web-ordering-pedido__summary_LentePronta ${this.state.open}`}
                style={{ background: "#f3f3f5", minHeight: "400px" }}>
                <div className={`lp-summary--arrowContainer ${this.state.arrow}`} onClick={this.openSummary}>
                  <span
                    id="btn-toggle-resumo"
                    className={`lp-summary--arrow ${this.state.arrow}`}
                    onClick={this.openSummary}></span>
                </div>
                <div className={`row x-web-ordering-pedido__summary--container ${this.state.arrow}`}>
                  <div className="col-12">
                    <div className="x-user-consultant__left">
                      <h1 id="logoLentePronta" className="x-user-consultant__title">
                        <img
                          src="image/modulos/logo_conecta_lente_pronta.png"
                          width="45%"
                          alt="Logo Lente Pronta"
                        />
                      </h1>
                    </div>
                  </div>

                  <div className="col-12">
                    <Typography variant="subtitle1" style={{ color: "#00518b", fontSize: "1rem", fontWeight: 500 }}>
                      Laboratório:
                    </Typography>
                  </div>
                  <div className="logolab col-12 my-4">
                    <img src={this.state.laboratorio.logo} width="178" height="120" alt="Logo laboratório" />
                  </div>

                  <div className="col-12 mt-3">
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#00518b" }}>
                      Dúvidas? Entre em contato com o laboratório
                    </Typography>
                    {this.state.laboratorio?.telefone && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                        <strong>Telefone:</strong> {this.state.laboratorio.telefone}
                      </Typography>
                    )}
                    {this.state.laboratorio?.email && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                        <strong>Email:</strong> {this.state.laboratorio.email}
                      </Typography>
                    )}
                    {this.state.laboratorio?.site && (
                      <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                        <strong>Site:</strong> {this.state.laboratorio.site}
                      </Typography>
                    )}
                  </div>

                  {this.state.hasOrcamento && (
                    <Box className="col-12" mt={3}>
                      <SummaryAccordion
                        sections={[
                          {
                            id: "dadosPedido",
                            title: "Dados do Pedido",
                            items: [
                              { label: "Nº do pedido da ótica", value: this.state.numeroPedido },
                              { label: "Empresa de faturamento", value: this.state.empresaFaturamento || CnpjUtils.formatCnpj(this.state.dados_empresa_faturamento_cnpj) || "-" },
                            ],
                          },
                          {
                            id: "produtos",
                            title: "Produtos",
                            items: [
                              { label: "Produto", value: this.state.linhaProduto?.nome || this.state.produtos[0]?.descricao },
                              {
                                label: "Olhos",
                                value: this.state.prescricaoOlhos === "ambos" ? "Ambos" : this.state.prescricaoOlhos === "direito" ? "OD" : "OE",
                              },
                              (this.state.prescricaoOlhos === "ambos" || this.state.prescricaoOlhos === "direito") && {
                                label: "OD",
                                value: `Esf ${this.state.prescricao_OD?.esferico} / Cil ${this.state.prescricao_OD?.cilindrico}`,
                              },
                              (this.state.prescricaoOlhos === "ambos" || this.state.prescricaoOlhos === "esquerdo") && {
                                label: "OE",
                                value: `Esf ${this.state.prescricao_OE?.esferico} / Cil ${this.state.prescricao_OE?.cilindrico}`,
                              },
                              this.state.pacto?.useVoucher && this.state.pacto?.selectedVoucher?.pilar && {
                                label: "Voucher Pacto",
                                value: this.state.pacto.selectedVoucher.pilar,
                              },
                              this.state.pacto?.useVoucher && this.state.pacto?.selectedVoucher?.codigo && {
                                label: "Código do Voucher Pacto",
                                value: this.state.pacto.selectedVoucher.codigo,
                                wordBreak: true,
                              },
                            ],
                          },
                          {
                            id: "dadosAdicionais",
                            title: "Dados Adicionais",
                            items: [
                              { label: "Observação", value: this.state.observacao || "-" },
                            ],
                          },
                        ]}
                      />
                    </Box>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    );
  }
}

export default LentePronta;
